import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "@firebase/firestore"
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyC2jYsF1S0RTQIWRshdAuk_eBowtQpIxOo",
  authDomain: "authentication-tut-1dc71.firebaseapp.com",
  projectId: "authentication-tut-1dc71",
  storageBucket: "authentication-tut-1dc71.firebasestorage.app",
  messagingSenderId: "745532445452",
  appId: "1:745532445452:web:bea2139b91759aea6eef29",
  measurementId: "G-61C6BRB5ZM"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
